import { InputTypeValue } from './Input.constants'

export function isInputTypeValuePassword(type) {
  return type === InputTypeValue.Password
}
